import { useContext } from 'react';

import productContext from 'contexts/productContext';

function useProduct() {
  return useContext(productContext);
}

export default useProduct;
